<template>
  <section id="champions"></section>
</template>

<script>
import Portfolio from "../assets/portfolio.json";
export default {
  data() {
    return { Portfolio };
  }
};
</script>

<style>
#champions {
  background: url("../assets/lanterns.jpg") center no-repeat fixed;
  background-size: cover;
  height: 150px;
  color: white;
  padding: 2rem 0;
  color: white;
  font-size: 3rem;
}
</style>